import React from 'react';
import { useScheduleContext } from '../../../context/ScheduleContext';
import { PAGES_VIEW_GRID } from '../../../constants/page-settings/schedule';
import { isMobile } from 'react-device-detect';
import ScheduleLineAndTileView from './ScheduleLineAndTileView';
import ScheduleGridView from './ScheduleGridView';
import ScheduleGridMobileView from './ScheduleGridMobileView';

const ScheduleView = ({ isActiveFavorites, onEpisodeClick, checkAuth, onRateEpisode, currentUser }) => {
    const {scheduleFilters} = useScheduleContext();

    if (scheduleFilters.scheduleView === PAGES_VIEW_GRID && !isActiveFavorites) {
        return !isMobile ? (
            <ScheduleGridView
                checkAuth={checkAuth}
                onRateEpisode={onRateEpisode}
                currentUser={currentUser}
            />
        ) : (
            <ScheduleGridMobileView
                checkAuth={checkAuth}
                onRateEpisode={onRateEpisode}
                currentUser={currentUser}
            />
        )
    }

    return (
        <ScheduleLineAndTileView
            isActiveFavorites={isActiveFavorites}
            onEpisodeClick={onEpisodeClick}
            checkAuth={checkAuth}
            onRateEpisode={onRateEpisode}
            currentUser={currentUser}
        />
    )
};

export default ScheduleView;
 